import * as React from "react";

export const OpenEye: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "$gray-600",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M2.598 10.39a.82.82 0 0 1 0-.78C4.175 6.694 7.088 4.167 10 4.167s5.825 2.527 7.402 5.444c.13.242.13.537 0 .78-1.577 2.915-4.49 5.442-7.402 5.442s-5.825-2.527-7.402-5.444"
    ></path>
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M11.768 8.232a2.5 2.5 0 1 1-3.536 3.536 2.5 2.5 0 0 1 3.536-3.536"
    ></path>
  </svg>
);
